module.exports = __webpack_public_path__ + "media/images/ads/pro-users-vertical-d1963e70a48a6ffa660708ef6da45271.png";